export default __webpack_public_path__ + "static/media/icon_editor_image.3409f4eb.svg";